import { type ReactNode } from 'react';
import { CreditNotesActions } from 'receivable-invoices-js/react/components/credit-notes/actions';
import { QuoteActions } from 'receivable-invoices-js/react/components/quotes/actions';
import { ReceivableInvoicesActions } from 'receivable-invoices-js/react/components/receivable-invoices/actions';
import type { Quote } from 'receivable-invoices-js/react/api/models/quote';
import type { CreditNote } from 'receivable-invoices-js/react/api/models/credit-note';
import type { ReceivableInvoice } from 'receivable-invoices-js/react/api/models/receivable-invoice';
import type { PaymentLink } from 'receivable-invoices-js/react/api/models/payment-link';

interface MobileActionsProps {
  document: Quote | CreditNote | ReceivableInvoice;
  type?: 'invoice' | 'quote' | 'credit-note';
  paymentLink?: PaymentLink | null;
  downloadAll: () => Promise<void>;
  hasAttachments: boolean;
}

export function MobileActions({
  document,
  type,
  paymentLink,
  downloadAll,
  hasAttachments,
}: MobileActionsProps): ReactNode {
  if (type === 'credit-note') {
    return (
      <CreditNotesActions data-testid="mobile-actions-credit-note" pdfUrl={document.pdfUrl || ''} />
    );
  }
  if (type === 'quote') {
    return <QuoteActions data-testid="mobile-actions-quote" pdfUrl={document.pdfUrl || ''} />;
  }

  const invoiceDoc = document as ReceivableInvoice;
  return (
    <ReceivableInvoicesActions
      data-testid="mobile-actions-invoice"
      downloadAll={downloadAll}
      hasAttachments={hasAttachments}
      hideDownloadButton={!invoiceDoc.pdfUrl}
      invoiceId={invoiceDoc.id}
      invoiceStatus={invoiceDoc.status}
      pdfUrl={invoiceDoc.pdfUrl || ''}
      sddEnabled={invoiceDoc.directDebitEnabled || false}
      showPayCTA={!paymentLink}
    />
  );
}
